import { getElements, ifSelectorExist } from "./utils";

export default function playVideoBtn() {
  const videoBtns = getElements(".single_video_preview__btn");
  const videoIframes = getElements(".single_video__iframe");

  if (ifSelectorExist(videoBtns) && ifSelectorExist(videoIframes)) {
    videoBtns.forEach((videoBtn, index) => {
      const videoIframe = videoIframes[index];

      videoBtn.addEventListener("click", () => {
        videoBtn.remove();
        videoIframe.play();
        videoIframe.controls = true;
      });
    });
  }
}
